import React from 'react';
import './App.css';
import {useIntl} from 'react-intl'
import MediaSlider from './components/Slider/MediaSlider';
function App() {
  const intl = useIntl();
  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <div className="w-full max-h-[60vh] md:max-h-[65vh]" style={{height: 'calc(100vh - 100px)'}}>
        <MediaSlider 
          slides={[
            {
              type: 'video',
              headline: intl.formatMessage({
                id: 'cert-needs',
                defaultMessage: 'Solving your <em>certification needs</em> with confidence and security'
              }),
              value: '/video/city-scape-video.mp4',
              overlayGradient: 'linear-gradient(89.87deg, #002857 0.1%, rgba(2, 41, 82, 0.567463) 44.32%, rgba(5, 42, 77, 0) 92.32%)'
            },
            {
              type: 'video',
              headline: intl.formatMessage({
                id: 'facilitating-compliance',
                defaultMessage: 'Facilitating compliance with <em>Official Mexican Standards</em>'
              }),
              value: '/video/family-study.mp4',
              overlayGradient: 'linear-gradient(89.87deg, #002857 0.1%, rgba(2, 41, 82, 0.567463) 44.32%, rgba(5, 42, 77, 0) 92.32%)'
            },
            {
              type: 'video',
              headline: intl.formatMessage({
                id: 'tech-sectors',
                defaultMessage: 'For the <em>technology sectors</em> within our reach'
              }),
              value: '/video/field-tech.mp4',
              overlayGradient: 'linear-gradient(89.87deg, #002857 0.1%, rgba(2, 41, 82, 0.567463) 44.32%, rgba(5, 42, 77, 0) 92.32%)'
            },
          ]}
        />
      </div>
      <div className="w-full flex flex-col items-center justify-center bg-main p-5 relative min-h-[200px]">
        <h1 className='text-2xl uppercase mb-4 text-secondary font-semibold text-center'>
          {intl.formatMessage({
            id: 'welcome-to',
            defaultMessage: "Welcome to Mexico Certifying Body S.C."
          })}
        </h1>
        <hr className='w-60 border-white -mt-3 mb-6'/>
        <h3 className='text-white text-lg text-center relative z-10' dangerouslySetInnerHTML={{__html: intl.formatMessage({
            id: 'comp-desc',
            defaultMessage: 'A product certification body dedicated to certifying the compliance of its products with Official Mexican Standards'
        })}}></h3>
        <img className="absolute left-0 bottom-0 z-0" src="/icons/home-hero-grid-accent.svg" alt="" />
      </div>
      <div className="w-full bg-white px-2 py-10 flex flex-col items-center justify-center">
        <h3 className='text-2xl uppercase text-secondary font-semibold mb-6'>
          {intl.formatMessage({
            id: 'cert-scope',
            defaultMessage: 'Our Certification Scope'
          })}
        </h3>
        <div className="w-full mx-6 bg-main flex resp-row-col justify-around max-w-[1000px] flex-wrap">
          <a href="/certification-services/electronics" className='w-full md:w-1/3 flex flex-col items-center justify-center hover-bg-secondary py-10'>
            <div className="flex flex-col h-[170px] w-[170px] rounded-full bg-white items-center justify-center">
              <img className='w-16' src="/icons/cert-elect.svg" alt="Electrical Engineering Certification" />
            </div>
            <p className="text-white text-center text-lg mt-4 h-16 w-16 flex items-center justify-center uppercase">
              {
                intl.formatMessage({
                  id: 'elec-eng',
                  defaultMessage: 'Electrical Engineering'
                })
              }
            </p>
          </a>
          <a href="/certification-services/telecommunications" className='w-full md:w-1/3 flex flex-col items-center justify-center hover-bg-secondary py-10'>
            <div className="flex flex-col h-[170px] w-[170px] rounded-full bg-white items-center justify-center">
              <img className='w-20' src="/icons/cert-tele.svg" alt="Telecommunications Certification" />
            </div>
            <p className="text-white text-center text-lg mt-4 h-16 w-16 flex items-center justify-center uppercase">
              {
                intl.formatMessage({
                  id: 'telecoms',
                  defaultMessage: 'Telecommunications'
                })
              }
            </p>
          </a>
          <a href="/certification-services/energy-efficiency" className='w-full md:w-1/3 flex flex-col items-center justify-center hover-bg-secondary py-10'>
            <div className="flex flex-col h-[170px] w-[170px] rounded-full bg-white items-center justify-center">
              <img className='w-20' src="/icons/cert-energy-eff.svg" alt="Energy Efficiency Certification" />
            </div>
            <p className="text-white text-center text-lg mt-4 h-16 w-16 flex items-center justify-center uppercase">
              {
                intl.formatMessage({
                  id: 'energy-eff',
                  defaultMessage: 'Energy Efficiency'
                })
              }
            </p>
          </a>
        </div>
        <div className="w-full flex flex-col min-h-[500px] relative mt-12 bg-cover bg-no-repeat bg-center" style={{backgroundImage: 'url(/img/staff-t-up.png)'}}>
          <div className="darken-image absolute w-full h-full"></div>
          <div className="w-full z-10 flex flex-col items-center justify-between min-h-[500px] pb-28">
            <h2 className="text-white font-bold text-center text-2xl my-6 uppercase">
              {
                intl.formatMessage({
                  id: "professional-commit",
                  defaultMessage: "Professional Commitment"
                })
              }
            </h2>
            <div className="w-full h-full resp-row-col justify-around items-center px-10 max-w-5xl gap-6">
              <div className="flex flex-col items-center justify-center">
                <div className="rounded-full w-[200px] h-[200px] border-color-secondary border-2 flex items-center justify-center">
                  <img className="w-20" src='/icons/prof-flag.svg' alt="Professional Flag" />
                </div>
                  <p className='text-center text-xl text-white mt-4 font-volk'>
                    {
                      intl.formatMessage({
                        id: "more-than-years",
                        defaultMessage: "More than 30 years",
                      })
                    }
                  </p>
              </div>
              <div className="flex flex-col items-center justify-center">
                <div className="rounded-full w-[200px] h-[200px] border-color-secondary border-2 flex items-center justify-center">
                  <img className="w-20" src='/icons/prof-portal.svg' alt="Portal" />
                </div>
                <p className='text-center text-xl text-white mt-4 font-volk'>
                  {
                    intl.formatMessage({
                      id: "portal",
                      defaultMessage: "Portal",
                    })
                  }
                </p>
              </div>
              <div className="flex flex-col items-center justify-center">
                <div className="rounded-full w-[200px] h-[200px] border-color-secondary border-2 flex items-center justify-center">
                  <img className="w-20" src='/icons/prof-laws.svg' alt="Laws" />
                </div>
                <p className='text-center text-xl text-white mt-4 font-volk'>
                  {
                    intl.formatMessage({
                      id: "laws",
                      defaultMessage: "Laws",
                    })
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full bg-white flex resp-row-col max-w-5xl gap-6 relative px-10 mt-8">
          <div className="sm:w-1/3 w-full flex flex-col justify-center items-center">
            <div className="w-[200px] h-[200px] bg-white border-color-secondary border-2 hover:border-black rounded-full p-1 z-10">
              <div className="w-full h-full rounded-full bg-secondary flex items-center justify-center">
                <h3 className="text-xl font-bold text-white">
                  {
                    intl.formatMessage({
                      id: 'experience',
                      defaultMessage: 'Experience'
                    })
                  }
                </h3>
              </div>    
            </div>
            <div className="w-full bg-gray-200 p-8 pt-36 -mt-28 min-h-[350px]">
              <p className="text-center">
                {
                  intl.formatMessage({
                    id: 'expert-staff',
                    defaultMessage: 'Highly staffed rated with more of 30 years of experience in the evaluation of the conformity in the security areas, telecommunications and efficiency energy.'
                  })
                }
              </p>
            </div>
          </div>
          <div className="sm:w-1/3 w-full flex flex-col justify-center items-center">
            <div className="w-[200px] h-[200px] bg-white border-color-secondary border-2 rounded-full hover:border-black p-1 z-10">
              <div className="w-full h-full rounded-full bg-secondary flex items-center justify-center">
                <h3 className="text-xl font-bold text-white">
                  {
                    intl.formatMessage({
                      id: 'effectiveness',
                      defaultMessage: 'Effectiveness'
                    })
                  }
                </h3>
              </div>    
            </div>
            <div className="w-full bg-gray-200 p-8 pt-36 -mt-28 min-h-[350px]">
              <p className="text-center">
                {
                  intl.formatMessage({
                    id: 'prac-proc',
                    defaultMessage: 'Highly staffed rated with more of 30 years of experience in the evaluation of the conformity in the security areas, telecommunications and efficiency energy.'
                  })
                }
              </p>
            </div>
          </div>
          <div className="sm:w-1/3 w-full flex flex-col justify-center items-center">
            <div className="w-[200px] h-[200px] bg-white border-color-secondary border-2 rounded-full hover:border-black p-1 z-10">
              <div className="w-full h-full rounded-full bg-secondary flex items-center justify-center">
                <h3 className="text-xl font-bold text-white">
                  {
                    intl.formatMessage({
                      id: 'vangaurd',
                      defaultMessage: 'Vangaurd'
                    })
                  }
                </h3>
              </div>    
            </div>
            <div className="w-full bg-gray-200 p-8 pt-36 -mt-28 min-h-[350px]">
              <p className="text-center">
                {
                  intl.formatMessage({
                    id: 'const-training',
                    defaultMessage: 'Highly staffed rated with more of 30 years of experience in the evaluation of the conformity in the security areas, telecommunications and efficiency energy.'
                  })
                }
              </p>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  );
}

export default App;
